export const WORKFLOW_CATALOG_SYNC_EVENT = "b3os:workflow-catalog-sync";

let workflowCatalogChannel: BroadcastChannel | null = null;

function getWorkflowCatalogChannel(): BroadcastChannel | null {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
    return null;
  }
  if (!workflowCatalogChannel) {
    workflowCatalogChannel = new BroadcastChannel(WORKFLOW_CATALOG_SYNC_EVENT);
  }
  return workflowCatalogChannel;
}

export function emitWorkflowCatalogSync(): void {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(WORKFLOW_CATALOG_SYNC_EVENT));
  getWorkflowCatalogChannel()?.postMessage({ type: "sync" });
}
